<div class="dropdown-wrapper">
    <ham-button
        #statusFilterButtonWrapper
        class="status-filter-button"
        size="base"
        variant="primary"
        outline="true"
        (click)="openFlyout(statusFilterButtonWrapper)"
    >
        {{ 'aumico_ui_export' | i18next }}
    </ham-button>
</div>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-content">
        <div *ngFor="let option of taskOptions">
            <label class="custom-checkbox status-option">
                <span>
                    <span
                        hamIconShapes
                        class="icon"
                        icon="{{ option.icon }}"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    ></span>
                    <span class="label">{{ option.label }}</span>
                </span>
                <input
                    type="checkbox"
                    [checked]="selectedStatus.includes(option.value)"
                    (change)="onStatusSelection(option.value, $event.target.checked)"
                />
            </label>
        </div>
        <div class="divider"></div>
        <div>
            <label class="custom-checkbox status-option">
                <span>
                    <span
                        hamIconShapes
                        class="icon"
                        icon="{{ includeAnnotationsOption.icon }}"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    ></span>
                    <span class="label">{{ includeAnnotationsOption.label }}</span>
                </span>
                <input
                    type="checkbox"
                    [checked]="selectedStatus.includes(includeAnnotationsOption.value)"
                    (change)="onStatusSelection(includeAnnotationsOption.value, $event.target.checked)"
                />
            </label>
        </div>
        <div>
            <label class="custom-checkbox status-option">
                <span>
                    <span
                        hamIconShapes
                        class="icon"
                        icon="{{ includeDocumentsOption.icon }}"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    ></span>
                    <span class="label">{{ includeDocumentsOption.label }}</span>
                </span>
                <input
                    type="checkbox"
                    [checked]="selectedStatus.includes(includeDocumentsOption.value)"
                    (change)="onStatusSelection(includeDocumentsOption.value, $event.target.checked)"
                />
            </label>
        </div>
        <div class="divider"></div>
        <div class="status-option" (click)="exportExcel()">
            <span
                hamIconShapes
                class="icon export-icon"
                icon="assets/hamIcons/file-export-outline.svg"
                [variant]="'transparent'"
                [size]="'regular'"
            ></span>
            <span class="label export-button">{{ 'aumico_reports_cpmm_export_tasks' | i18next }}</span>
        </div>
    </div>
</span>
